var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"width":"35","show-modal":_vm.showModal},on:{"close-modal":_vm.closeModal}},[_c('div',{staticClass:"delete-modal"},[_c('div',{staticClass:"flex justify-center"},[_c('handoff-svg')],1),_c('div',{staticClass:"my-6"},[_c('p',[_vm._v(_vm._s(_vm.type)+" Completed")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }